import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBkztCHOZVUz6fXovH0C1jvOx-vADGjI6o",
  authDomain: "pta-training-resources.firebaseapp.com",
  projectId: "pta-training-resources",
  storageBucket: "pta-training-resources.firebasestorage.app",
  messagingSenderId: "640143714627",
  appId: "1:640143714627:web:e6c354e660ee4199eda7f6"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };
